import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, shareReplay, throwError } from 'rxjs';
import { ApiResponse } from '../models/ApiResponse';
import { API_URL } from './api-url';

@Injectable({
  providedIn: 'root'
})
export class RouteService {

  readonly http = inject(HttpClient)
  private frontendRoutes$?: Observable<string[]>;

  constructor() { }

  getFrontendRoutes(): Observable<string[]> {
    if (!this.frontendRoutes$) {
      this.frontendRoutes$ = this.http.get<ApiResponse<string[]>>(API_URL + '/api/routes/fe').pipe(
        map(res => res.data),
        catchError((error) => {
          this.frontendRoutes$ = undefined;
          return throwError(() => error);
        }),
        shareReplay(1)
      );
    }

    return this.frontendRoutes$;
  }

}
